import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { OAuthService } from "angular-oauth2-oidc";
import { Observable } from "rxjs";
import { System } from "src/app/authentication/models/system.model";
import { environment } from "src/environments/environment";

@Injectable()
export class UsersService {
  apiUrl: string;
  userAdminSystems: System[];
  isAdmin: boolean = true;
  isAdmin$: Observable<boolean>;

  constructor(private http: HttpClient, private snackBar: MatSnackBar, private oAuthService: OAuthService) {
    this.apiUrl = environment.apiUris.chartsApiUri;
  }

  public checkIsAdmin(): Observable<boolean> {
    this.isAdmin$ = this.http.get<any>(`${this.apiUrl}/IsAdmin`);
    this.isAdmin$.subscribe((res: boolean) => {
      this.isAdmin = res;
    });
    return this.isAdmin$;
  }
}
